import styles from './WelcomeModalSection.module.scss';
import { VdsButton, VdsLink } from '@volt/volt-extended-components-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useCallback } from 'react';

export enum ModalSectionActionType {
  Link,
  Action,
}

interface ActionBase {
  type: ModalSectionActionType;
  label: string;
}

interface LinkData extends ActionBase {
  type: ModalSectionActionType.Link;
  url: string;
}

interface ActionData extends ActionBase {
  type: ModalSectionActionType.Action;
  action: () => void;
}

export interface WelcomeModalSectionData {
  title: string;
  description: string | null;
  actions: (LinkData | ActionData)[];
}

interface WelcomeModalSectionProps extends WelcomeModalSectionData {
  onClose: () => void;
}

export const WelcomeModalSection = ({
  title,
  description,
  actions,
  onClose,
}: WelcomeModalSectionProps) => {
  const { t } = useTranslation();

  const onClickAction = useCallback(
    (action: () => void) => {
      action();
      onClose();
    },
    [onClose],
  );

  return (
    <section className={styles.section}>
      <header className={styles.section__title}>{t(title)}</header>
      {description && <div className={styles.section__description}>{t(description)}</div>}
      <footer className={styles.section__footer}>
        {actions.map((action: LinkData | ActionData, i) => {
          return action.type === ModalSectionActionType.Action ? (
            <VdsButton
              key={action.label}
              onClick={() => onClickAction(action.action)}
              variant="tertiary"
              size="medium"
              className={styles.section__button}
            >
              {t(action.label)}
            </VdsButton>
          ) : (
            <Link key={action.label} to={action.url} onClick={onClose}>
              {/* The following VdsLink is for display only. All routing and logic performed by parent Link. */}
              <VdsLink value={t(action.label)} size="small" underline={true} />
            </Link>
          );
        })}
      </footer>
    </section>
  );
};

export default WelcomeModalSection;
